export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Common.json?hash=91bf15b909955c4c9d99171c2dd92699";